'use client';

import Loading from '@/components/loading';

export default function PageLoading() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loading size={32} />
    </div>
  );
}
